export default {"src":"/login-app/[GIT_HASH]/_next/static/media/data_reliability.ac30fb4a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};